// Campaign params the GIWL application uses for attribution. They are also
// persisted as cookies server-side by CookieValuesValve, so they can be
// recovered when the current page URL doesn't carry them.
export var REDIRECT_CAMPAIGN_PARAMS = ["cc", "sc", "cmp"];

/**
 * resolveRedirectCampaignParams
 *
 * Returns a copy of pageParams with any missing campaign param (cc, sc, cmp)
 * filled in from the campaign cookie of the same name. Values present on the
 * page URL take precedence; every other page URL param is kept as-is. This
 * covers visitors who arrived with campaign params on an earlier page (e.g. a
 * term-quote landing) but reached the GIWL quote page with a bare URL — without
 * the fallback their attribution would be dropped from the redirect and default
 * to the generic GIWL campaign.
 *
 * getCookie is injected (rather than imported) to keep this module pure and
 * unit-testable; it should return "" when the cookie is absent.
 */
export function resolveRedirectCampaignParams(pageParams, getCookie) {
    var resolved = Object.assign({}, pageParams || {});

    REDIRECT_CAMPAIGN_PARAMS.forEach(function (key) {
        if (resolved[key]) {
            return;
        }

        var cookieValue = getCookie(key);
        if (cookieValue) {
            resolved[key] = cookieValue;
        }
    });

    return resolved;
}

/* resolveRedirectSessionId */
export function resolveRedirectSessionId(aggregateResponse, renderedSessionId) {
    if (aggregateResponse && aggregateResponse.aggregationSessionId) {
        return aggregateResponse.aggregationSessionId;
    }
    return renderedSessionId;
}
